import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { Bin } from '../../types/bin/bin';
import { BinFragment } from '../../graphql/bin.graphql';
import { useAppDispatch } from '../../ui/pages/store';
import { binSlice } from '../../providers/BinProvider';

const binSubscription = gql`
  subscription binNotification($companyId: String!) {
    binNotification(companyId: $companyId) {
      companyId
      entities {
        ...Bin
      }
      topic
      date
    }
  }
  ${BinFragment.bin}
`;

export class BinNotificationResponse extends forNotification<Bin>('binNotification') {}

export default function BinNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: binNotification } = useSubscription<BinNotificationResponse>(binSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleBinNotification = (notification?: BinNotificationResponse) => {
    if (!notification?.binNotification) return;
    const binNotification = notification.binNotification;

    switch (binNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(binSlice.actions.add(binNotification.entities));
        break;
      case 'DELETE':
        dispatch(binSlice.actions.delete(binNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleBinNotification(binNotification);
  }, [binNotification]);

  return <></>;
}
